import axios from 'axios'
import { serverAPI } from '../../index'
// Action types
export const CHANGE_VISIBLE = 'change_visible'
export const CHANGE_TITLE = 'change_title'
export const CHANGE_TEXT = 'change_text'

// Axios
const mediatorAPI = axios.create({
  baseURL: 'https://mediator.semprocesso.com.br'
})

export const changeVisible = (visible) => {
  return {
    type: CHANGE_VISIBLE,
    payload: visible
  }
}

export const changeTitle = (title) => {
  return {
    type: CHANGE_TITLE,
    payload: title
  }
}

export const changeText = (text) => {
  return {
    type: CHANGE_TEXT,
    payload: text
  }
}

export const fetchMediate = (id, lastTitle = '', lastText) => {
  return dispatch => {
    mediatorAPI.get(`/mediate?id=` + id)
      .then(response => {
        if (response.data) {
          const { title, text } = response.data

          if (lastTitle !== title && lastText !== text) {
            dispatch(changeVisible(false))
            dispatch(changeTitle(title))
            dispatch(changeText(text))
            dispatch(changeVisible(true))
          }
        }
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const newMediate = (id, lastTitle = '', lastText) => {
  return dispatch => {
    serverAPI.get(`/mediator/get-message?id=` + id)
      .then(response => {
        if (response.data) {
          const { title, text } = response.data

          if (lastTitle !== title && lastText !== text) {
            dispatch(changeVisible(false))
            dispatch(changeTitle(title))
            dispatch(changeText(text))
            dispatch(changeVisible(true))
          }
        }
      })
      .catch(e => {
        console.log(e)
      })
  }
}
